import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

const Privacy = () => {
  return (
    <>
      <Navigation />
      <main className="main-content">
        <div className="page-container">
          <div className="container">
            <h1>Privacy Policy</h1>
            <p>Last updated: {new Date().toLocaleDateString()}</p>

            <section className="policy-section">
              <h2>1. Information We Collect</h2>
              <p>When you use AumLaut, we collect:</p>
              <ul>
                <li>URLs you submit for shortening</li>
                <li>Visit statistics for your shortened URLs</li>
                <li>Account information (email) if you register</li>
                <li>Usage data to improve our service</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>2. How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul>
                <li>Provide URL shortening services</li>
                <li>Track URL visit statistics</li>
                <li>Improve our services</li>
                <li>Send important account notifications</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>3. Data Security</h2>
              <p>We implement security measures to protect your information, including:</p>
              <ul>
                <li>Encryption of sensitive data</li>
                <li>Regular security audits</li>
                <li>Secure data storage practices</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>4. Contact Us</h2>
              <p>If you have questions about this Privacy Policy, please contact us at privacy@aumlaut.com</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Privacy;
